<template>
  <div class="list" style="width:100%">
    <Header :title="$t('m.ModifyAppointmentMeeting')"></Header>
    <div class="content spebgc">
      <div class="item">
        <span class="item_label">{{$t('m.ConferenceNo')}}</span>
        <span class="item_content">
          <input
            disabled
            :placeholder="$t('m.PlsEnterMeetingNo')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_code"
          />
        </span>
        <span class="item_right">
          <CheckboxGroup @on-change="clearcode" v-model="meetingpre.vmr_id">
            <Checkbox disabled label="1">
              <span>{{$t('m.RandomMeetingNo')}}</span>
            </Checkbox>
          </CheckboxGroup>
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingName')}}</span>
        <span class="item_content">
          <input
            :placeholder="$t('m.PlsEnterMeetingName')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            type="text"
            v-model="meeting.meeting_name"
          />
        </span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingPassword')}}</span>
        <span class="item_content">
          <input
            :disabled="!meetingpre.vmr_id[0]"
            :type="meetingpre.password_display[0]=='1'?'password':'number'"
            :placeholder="$t('m.PlsEnterMeetingPassword')"
            style="width:100%;border:none;outline:none;height:0.45rem"
            v-model="meeting.meeting_password"
          />
        </span>
        <span class="item_right">
          <CheckboxGroup v-model="meetingpre.password_display">
            <Checkbox :disabled="!meetingpre.vmr_id[0]" label="1">
              <span>{{$t('m.HidePassword')}}</span>
            </Checkbox>
          </CheckboxGroup>
        </span>
      </div>
    </div>
    <div class="content spebgc">
      <div class="item">
        <RadioGroup v-model="meeting.meeting_type">
          <Radio label="1">
            <span>{{$t('m.InstantConference')}}</span>
          </Radio>
          <Radio label="2">
            <span>{{$t('m.ReservedConference')}}</span>
          </Radio>
        </RadioGroup>
      </div>
      <div class="item" v-show="meeting.meeting_type==2">
        <span class="item_label">{{$t('m.MeetingDate')}}</span>
        <span style="width:38%;">
          <DatePicker
            id="datePickerId"
            v-model="datavalue"
            type="date"
            :placeholder="$t('m.SelectDate')"
            :options="optionsDisabled"
            format="yyyy-MM-dd"
            @on-change="datavalue=$event;datavalueChange=true"
            @click.native="activeDate=true"
          ></DatePicker>
        </span>
        <span style="width:38%;">
          <TimePicker
            id="timePickerId"
            v-model="timevalue"
            format="HH:mm"
            :placeholder="$t('m.MeetingTime')"
            @click.native="activeDate=true"
          ></TimePicker>
        </span>

        <span style="width:1.33rem;"></span>
      </div>
      <div class="item" v-show="meeting.meeting_type==1">
        <span class="item_label">{{$t('m.MeetingDate')}}</span>
        <span class="item_content">{{meeting.meeting_date}}</span>
      </div>
      <div class="item">
        <span class="item_label">{{$t('m.MeetingDuration')}}</span>
        <span style="width:40%">
          <TimePicker
            id="timePickerLong"
            v-model="meeting_longi"
            format="HH:mm"
            :placeholder="$t('m.MeetingDuration')"
            @click.native="activeDate=true"
          ></TimePicker>
        </span>
      </div>
      <div
        class="item"
        style="height:auto;padding:0.1rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.MeetingIntroduce')}}</span>
        <span style="width:75%">
          <Input
            :autosize="true"
            :placeholder="$t('m.PlsEnterMeetingIntroduce')"
            style="margin:0;padding:0"
            type="textarea"
            v-model="meeting.meeting_content"
          />
        </span>
      </div>
    </div>
    <div class="content spebgc">
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.Participants')}}</span>
        <span @click="tochoicepeople">
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{peoplechoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.ConferenceTerminal')}}</span>
        <span @click="tochoiceroom">
          <img :src="imgpath.room" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{roomchoice}}
      </div>
      <div
        class="item"
        style="height:auto;padding:0.10rem 0;line-height:0.3rem;box-sizing:content-box"
      >
        <span class="item_label">{{$t('m.ConferenceHost')}}</span>
        <span @click="tochoicehost()">
          <img :src="imgpath.people" style="width:0.2rem;vertical-align: middle" />
        </span>
        {{hostchoice}}
      </div>
    </div>
    <div class="content spebgc" v-if="hasmediasuite">
      <div class="item">
        <CheckboxGroup style="float:left" v-model="meetingpre.cf_record">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceRecord')}}</span>
          </Checkbox>
        </CheckboxGroup>
        <CheckboxGroup style="float:left" v-model="meetingpre.cf_live">
          <Checkbox label="1">
            <span>{{$t('m.ConferenceLive')}}</span>
          </Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="content spebgc" style="text-align:center">
      <div @click="sub" class="button bgc">{{$t('m.SaveBtn')}}</div>
      <div @click="goback" class="button bdc color">{{$t('m.Return')}}</div>
    </div>

    <div class="pop" v-if="editsure">
      <div class="templatepopexit">
        <div class="popclosex" @click="editsure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="hookUrl" />
          <span class="title_sure">{{$t('m.ModifyBtn')}}</span>
        </div>
        <div class="templatepoptop">
          {{$t('m.Meeting')}}（{{meeting.meeting_name ||
          ""}}）{{$t('m.ModifyOK')}}
        </div>
        <div @click="editsure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="editsureSuccess" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import { changemeeting } from "../../assets/js/url";
import "../../../static/css/normalize3.0.2.min.css";
import "../../..//static/css/style.css?v=7";
import "../../..//static/css/mobiscroll.css";
import "../../..//static/css/mobiscroll_date.css";

export default {
  name: "attendmeeting",
  data() {
    return {
      hookUrl: require("@/assets/images/public/hook.png"),
      activeDate: false,
      optionsDisabled: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      datavalueChange:false,
      editsure: false,
      datavalue: "",
      timevalue: "",
      langvalue: "",
      meetingpre: {
        vmr_id: ["1"],
        password_display: [],
        cf_record: [],
        cf_live: []
      },
      meeting_longi: "01:00",
      meeting: {
        useruuid: window.sessionStorage.getItem("UUID"),
        meeting_name: "",
        meeting_code: "",
        meeting_password: "",
        password_display: "",
        meeting_type: "1",
        meeting_date: "",
        meeting_long: "",
        meeting_content: "",
        vmr_id: "",
        cf_party: "",
        cf_terminal: "",
        cf_host: "",
        cf_record: "",
        cf_live: ""
      }
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    peoplechoice() {
      return this.$store.state.meeting.cfpartyname.replace(/,/g, "，");
    },
    hostchoice() {
      return this.$store.state.meeting.cfhostname.replace(/,/g, "，");
    },
    roomchoice() {
      return this.$store.state.meeting.cfterminalname.replace(/,/g, "，");
    },
    hasmediasuite() {
      return this.$store.state.hasmediasuite;
    }
  },
  components: {
    Header
  },
  watch: {
    activeDate(a, b) {
      let that = this;
      that.$nextTick(function() {
        $("#datePickerId input").focus(function() {
          document.activeElement.blur();
        });
        $("#timePickerId input").focus(function() {
          document.activeElement.blur();
        });
        $("#timePickerLong input").focus(function() {
          document.activeElement.blur();
        });
      });
    }
  },

  activated() {
    this.init();
    this.getnowtime();
    // this.datachoice();
  },
  attendinit() {
    // 记录store归零，暂时不用
    this.$store.commit("setmeetingcfparty", "");
    this.$store.commit("setmeetingcfpartyname", "");
    this.$store.commit("setmeetingcfhost", "");
    this.$store.commit("setmeetingcfhostname", "");
    this.$store.commit("setmeetingcfparty", "");
    this.$store.commit("setmeetingcfparty", "");
    this.$store.commit("setmeetingcfterminal", "");
    this.$store.commit("setmeetingcfterminalname", "");
  },
  methods: {
    goback() {
      this.$router.go(-1);
      this.attendinit();
    },

    getnowtime() {
      const time = new Date();
      const year = time.getFullYear();
      const mouth =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      const day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      const h = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
      const m =
        time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
      const s =
        time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
      this.meeting.meeting_date =
        year + "-" + mouth + "-" + day + "  " + h + ":" + m + ":" + s;
    },
    getdata(value) {
      // const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      // const year = data.getFullYear();
      // const mouth =
      //   data.getMonth() + 1 < 10
      //     ? "0" + (data.getMonth() + 1)
      //     : data.getMonth() + 1;
      // const day = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
      // return year + "/" + mouth + "/" + day;
      let data = value.split(' ')[0]
      return data
    },
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const h = data.getHours() < 10 ? "0" + data.getHours() : data.getHours();
      const m =
        data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();
      const s =
        data.getSeconds() < 10 ? "0" + data.getSeconds() : data.getSeconds();
      return h + ":" + m + ":" + s;
    },
    init() {
      let meeting = JSON.parse(window.sessionStorage.getItem("meeting"));
      // if (this.$route.params.meeting) {
      //   var meeting = this.$route.params.meeting;
      // } else {
      //   // this.$router.push('/attendmeetinglist')
      // }
      this.meeting.id = meeting.id;
      this.meeting.meetinguuid = meeting.meetinguuid;
      this.meetingpre.cf_live = meeting.cf_live == 1 ? ["1"] : [];
      this.meetingpre.cf_record = meeting.cf_record == 1 ? ["1"] : [];
      this.meeting.meeting_code = meeting.meeting_code;
      this.meeting.meeting_password = meeting.meeting_password;
      this.meeting.meeting_name = meeting.meeting_name;
      this.meeting.vmr_id = meeting.vmr_id;
      this.meeting.meeting_code = meeting.vmr_id;
      this.meeting.meeting_content = meeting.meeting_content;
      // "meeting_content" in meeting ? meeting.meeting_content : "";
      // 随机会议以及及时会议等问题初始化
      this.meeting.meeting_type = meeting.meeting_type + "";
      this.datavalue = this.getdata(meeting.meeting_date);
      this.timevalue = this.gettime(meeting.meeting_date);
      sessionStorage.setItem('_datavalue',this.datavalue)
      let hours =
        (meeting.meeting_long - (meeting.meeting_long % 60)) / 60 < 10
          ? "0" + (meeting.meeting_long - (meeting.meeting_long % 60)) / 60
          : (meeting.meeting_long - (meeting.meeting_long % 60)) / 60;
      let minutes =
        meeting.meeting_long % 60 == 0
          ? "00"
          : meeting.meeting_long % 60 < 10
          ? "0" + (meeting.meeting_long % 60)
          : meeting.meeting_long % 60;
      this.meeting_longi = hours + ":" + minutes;

      // this.$store.commit("setmeetingcfparty", meeting.cf_party);
      // this.$store.commit("setmeetingcfterminal", meeting.cf_terminal);
      // this.$store.commit("setmeetingcfhost", meeting.cf_host);
      // //与会人员
      // this.$store.commit("setmeetingcfpartyname", meeting.cf_party_name);
      // this.$store.commit("setmeetingcfterminalname", meeting.cf_terminal_name);
      // this.$store.commit("setmeetingcfhostname", meeting.cf_host_name);
      if(this.$route.params.from=="terminalcontrolPctest"){
        let _meeting = JSON.parse(window.sessionStorage.getItem("_meeting"));
        // console.log(_meeting.datavalue)
        this.activeDate = _meeting.activeDate;
        this.datavalue = _meeting.datavalue;
        this.datavalueChange = _meeting.datavalueChange;
        this.editsure = _meeting.editsure;
        this.meeting = _meeting.meeting;
        this.meeting_longi = _meeting.meeting_longi;
        this.meetingpre = _meeting.meetingpre;
        this.optionsDisabled = _meeting.optionsDisabled;
        this.timevalue = _meeting.timevalue
        window.sessionStorage.removeItem("_meeting")
      }
    },
    tochoicepeople() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfparty",
          canChoose: true,
          message: this.$store.state.meeting.cfparty //要在通讯录中把人标出来
        }
      });
    },
    tochoicehost() {
      this.$router.push({
        path: "/userlist",
        query: {
          name: "cfhost", //用这个字段区分
          canChoose: true,
          message: this.$store.state.meeting.cfhost //要在通讯录中把人标出来
        }
      });
    },
    tochoiceroom() {
      this.$router.push({
        //老版选取终端路由
        //name: "roomchoice",
        //新版选取终端路由
        name: "terminalcontrolPctest",
        query: {
          name: "cfterminal",
          fromrouter: "/changemeeting",
          message: this.$store.state.meeting.cfterminal,
          dateTimeValue: "" //在这个时间下
        },
        params: {
          meeting_vrmId: this.meeting.meeting_code
            ? this.meeting.meeting_code
            : 0,
          creatingTime:
            this.meeting.meeting_type == "2"
              ? this.datavalue + " " + this.timevalue + ":00"
              : "",
          meetingData:this.$data
        }
      });
    },
    clearcode() {
      if (this.meetingpre.vmr_id[0]) {
        this.meeting.meeting_code = "";
      }
    },
    sub() {
      this.meeting.password_display =
        this.meetingpre.password_display[0] == "1" ? 1 : 2;
      this.meeting.cf_record = this.meetingpre.cf_record[0] == "1" ? 1 : 2;
      this.meeting.vmr_id = this.meetingpre.vmr_id[0] == "1" ? 1 : 2;
      this.meeting.cf_live = this.meetingpre.cf_live[0] == "1" ? 1 : 2;
      this.meeting.cf_party = this.$store.state.meeting.cfparty;
      this.meeting.cf_host = this.$store.state.meeting.cfhost;
      this.meeting.cf_terminal = this.$store.state.meeting.cfterminal;
      let currentDate = '';
      if(this.datavalueChange){
        currentDate = this.datavalue
      }else{
        currentDate = sessionStorage.getItem('_datavalue')
      }
      this.meeting.meeting_date = currentDate + " " + this.timevalue;
      this.meeting.meeting_long =
        Number(parseInt(this.meeting_longi)) * 60 +
        Number(parseInt(this.meeting_longi.split(":")[1]));

      this.$loadingshow();
      this.$http.post(changemeeting, this.meeting).then(
        res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.editsure = true;
            this.meeting.id = res.data.data.meeting_id;
          } else {
            this.$toast(this.$t('m.ModifyFail'));
          }
        },
        err => {}
      );
    },
    editsureSuccess() {
      this.sure();
    },
    sure() {
      this.editsure = false;
      this.$router.push("/attendmeetinglist");
    }
  }
};
</script>
<style scoped>
.list {
  background: #f5f5f5;
  overflow: hidden;
}

.nav {
  height: 0.65rem;
  background-color: #fff;
  padding: 0.15rem 0.1rem;
  box-sizing: border-box;
}

input {
  background: transparent;
}

input:disabled {
  background: transparent;
  font-size: 0.14rem;
}

input:disabled:-moz-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled:-ms-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input:disabled::-webkit-input-placeholder {
  color: #ddd;
  font-size: 0.14rem;
}

input::-webkit-input-placeholder {
  font-size: 0.14rem;
}

.nav table {
  width: 100%;
  height: 0.38rem;
  border-radius: 4px;
  border-collapse: collapse;
  line-height: 0.35rem;
}

.nav table tr {
  height: 0.36rem;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.nav table tr td {
  width: 33.3333%;
  text-align: center;
  font-size: 0.13rem;
}

td.normal {
  border-top: none;
  border-bottom: none;
  border-left: none;
}

td.normal.active {
  color: #fff;
}

.content {
  margin-top: 0.1rem;
  padding: 0 0.15rem;
  background-color: #fff;
}

.radio {
  width: 0.15rem;
  height: 0.15rem;
  display: inline-block;
  border-radius: 100%;
  vertical-align: middle;
}

i {
  font-size: 0.25rem;
  vertical-align: middle;
}

.button {
  width: 1rem;
  height: 0.4rem;
  border-radius: 3px;
  margin: 0.1rem;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0.15rem;
  text-align: center;
  line-height: 0.4rem;
  font-size: 0.16rem;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/content/changemeeting.vue